export default "__VITE_ASSET__46022a8d__"